import React from "react";
import Instagram from "./Editors/Instagram";

export default class IComCustomGridEditor extends React.Component {

    constructor(props) {
        super(props);
        this.components = {
            instagram: Instagram
        }
    }

    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    render() {
        const serverRender = typeof window === 'undefined';

        const { model } = this.props;
        const viewName = model.value.icomCustomContentTypeAlias;
        const View = this.components[viewName];
        if (!View) {
            return ""; // No editor
        }
        return (
            <View {...this.props} model={model.value.value} />
        );

    }
}